<template>
  <div>
    <div class="schedule">
      <ul style="margin-right: -20px;">
        <li v-for="(week, weekKey) in template" :key="weekKey">
          <h5>{{ week.title }}</h5>
          <div class="controller">
            <label>Тип расписания</label>
            <select
              @change="init"
              v-model="template[weekKey]['is_change']"
              class="form-control mb-2"
              placeholder="Обычный"
            >
              <option :value="false">Обычный</option>
              <option :value="true">Мигалка</option>
            </select>
            <radio-list
              v-if="week.is_change"
              v-model="week.change"
              :name="`${weekKey}-change`"
              :items="[
                { title: 'ЧЕТ.', id: 'odd' },
                { title: 'НЕЧЕТ.', id: 'even' },
              ]"
            />
          </div>

          <ul>
            <template v-for="(schedule, scheduleKey) in week.schedules">
              <li
                v-if="
                  ((schedule.change === 'all' && !week.is_change) ||
                    (week.change == schedule.change && week.is_change)) &&
                  ((schedule.is_division && schedule.division > 0) ||
                    (!schedule.is_division && schedule.division == 0))
                "
                :key="`${scheduleKey}${weekKey}`"
              >

                <template>
                  <!-- {{schedule.change}} {{week.change}} {{week.is_change}} -->
                  <checkbox
                    v-if="schedule.division == 1 || schedule.division == 0"
                    @change="setDivision(schedule, weekKey)"
                    v-model="schedule.is_division"
                    >Разделение на группы</checkbox
                  >
                  <h6>
                    {{ schedule.position }} урок
                    <span v-if="schedule.division > 0">
                      - Группа: {{ schedule.division }}</span
                    >
                  </h6>
                  <selector
                    :params="{
                      group_id: id,
                      division: schedule.division,
                      timetable: 1,
                    }"
                    @input="init"
                    modal="business_discipline"
                    title="Предмет "
                    :prefix="`${scheduleKey}${weekKey}`"
                    v-model="schedule['discipline']"
                  />
                  <selector
                    @input="init"
                    modal="customer"
                    title="Учитель"
                    :prefix="`${scheduleKey}${weekKey}`"
                    selectKey="full_name"
                    v-model="schedule['customer']"
                  />
                </template>
              </li>
            </template>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  async mounted() {
    let schedules = await this.$http
      .get("schedules", { params: { key: true } })
      .then((response) => {
        let data = Object.values(response.data);
        let types = ["all", "odd", "even"];
        let returnData = {};
        for (let i = 0; i < data.length; i++) {
          for (let j = 0; j < types.length; j++) {
            returnData[`${data[i].id}-${types[j]}-1`] = {
              ...data[i],
              change: types[j],
              division: 1,
            };
            returnData[`${data[i].id}-${types[j]}-2`] = {
              ...data[i],
              change: types[j],
              division: 2,
            };
            returnData[`${data[i].id}-${types[j]}-3`] = {
              ...data[i],
              change: types[j],
              division: 3,
            };
            returnData[`${data[i].id}-${types[j]}-0`] = {
              ...data[i],
              change: types[j],
              division: 0,
            };
          }
        }
        return returnData;
      });
    await Object.keys(this.template).forEach((key) => {
      let templateSchedule = JSON.parse(JSON.stringify(schedules));

      for (let i = 0; i < this.value.length; i++) {
        if (
          this.value[i].week == key &&
          templateSchedule[
            `${this.value[i].schedule_id}-${this.value[i].change}-${this.value[i].subgroup_id}`
          ]
        ) {
          this.template[key].is_change = this.value[i].is_change;

          templateSchedule[
            `${this.value[i].schedule_id}-${this.value[i].change}-${this.value[i].subgroup_id}`
          ].discipline = JSON.parse(JSON.stringify(this.value[i].discipline));
          templateSchedule[
            `${this.value[i].schedule_id}-${this.value[i].change}-${this.value[i].subgroup_id}`
          ].customer = JSON.parse(JSON.stringify(this.value[i].customer));
          templateSchedule[
            `${this.value[i].schedule_id}-${this.value[i].change}-${this.value[i].subgroup_id}`
          ].subgroup_id = this.value[i].subgroup_id;

          templateSchedule[
            `${this.value[i].schedule_id}-${this.value[i].change}-${this.value[i].subgroup_id}`
          ].is_division = false; // 0

          if (this.value[i].is_division) {
            templateSchedule[
              `${this.value[i].schedule_id}-${this.value[i].change}-0`
            ].is_division = this.value[i].is_division;
            templateSchedule[
              `${this.value[i].schedule_id}-${this.value[i].change}-1`
            ].is_division = this.value[i].is_division;
            templateSchedule[
              `${this.value[i].schedule_id}-${this.value[i].change}-2`
            ].is_division = this.value[i].is_division;
            templateSchedule[
              `${this.value[i].schedule_id}-${this.value[i].change}-3`
            ].is_division = this.value[i].is_division;
          }
        }
      }
      this.template[key].schedules = templateSchedule;
    });

    setTimeout(() => {
      this.init();
    }, 10);
  },
  data: () => ({
    timetable: [],
    showOnly: {
      1: true,
      2: true,
      3: true,
      4: true,
      5: true,
      6: true,
      7: true,
    },
    template: {
      1: {
        title: "Понедельник",
        background: "#ebebeb",
        schedules: {},
        is_change: false,
      },
      2: {
        background: "#ebebeb",
        title: "Вторник",
        schedules: {},
        is_change: false,
      },
      3: {
        background: "#ebebeb",
        title: "Среда",
        schedules: {},
        is_change: false,
      },
      4: {
        background: "#ebebeb",
        title: "Четверг",
        schedules: {},
        is_change: false,
      },
      5: {
        background: "#ebebeb",
        title: "Пятница",
        schedules: {},
        is_change: false,
      },
      6: {
        background: "#ebebeb",
        title: "Суббота",
        schedules: {},
        is_change: false,
      },
      // 0: {
      //   background: "#ebebeb",
      //   title: "Воскресенье",
      //   schedules: {},
      //         is_change:false
      // },
    },
  }),
  methods: {
    setDivision(schedule, week) {
      const key = `${schedule.id}-${schedule.change}`;
      this.template[week]["schedules"][`${key}-0`]["is_division"] =
        schedule["is_division"];
      this.template[week]["schedules"][`${key}-1`]["is_division"] =
        schedule["is_division"];
      this.template[week]["schedules"][`${key}-2`]["is_division"] =
        schedule["is_division"];
      this.template[week]["schedules"][`${key}-3`]["is_division"] =
        schedule["is_division"];

      this.init();
    },
    async init() {
      let timetable = [];
      await Object.keys(this.template).forEach(async (keyWeek) => {
        const isChange = this.template[keyWeek].is_change;
        await Object.keys(this.template[keyWeek].schedules).forEach(
          (keySchedule) => {
            timetable.push({
              schedule: { id: keySchedule },
              discipline:
                this.template[keyWeek].schedules[keySchedule].discipline,
              customer: this.template[keyWeek].schedules[keySchedule].customer,
              subgroup_id:
                this.template[keyWeek].schedules[keySchedule].division,
              is_division:
                this.template[keyWeek].schedules[keySchedule].is_division,
              week: keyWeek,
              is_change: isChange,
            });
          }
        );
      });
      
      // if(!this.firstTimtables.length)
      //   for (let i = 0; i < le.length; i++) {
      //     const element = le[i];
      //     this.firstTimtables.push(element)
      //   }
      // console.log(this.value, 'valuevalue')
      await this.$emit("first", JSON.parse(JSON.stringify(timetable)));
      await this.$emit("input", timetable);
    },
  },
  props: {
    
    value: {
      default: function () {
        return [];
      },
    },
    id: {
      default: null,
    },
  },
  computed: {
    ...mapState(["business"]),
  },
};
</script>
